"use client";

import React, { FC, PropsWithChildren } from "react";
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  AttachmentsEditorProvider,
  useNextRouter,
  SignalRProvider
} from "@shesha-io/reactjs";
import { AppProgressBar } from "next-nprogress-bar";
import { useTheme } from "antd-style";

//import {  TelephonyProvider, TelephonyPlugin} from "@shesha-io/telephony";
import {  TelephonyProvider, TelephonyPlugin} from "../../packages/telephony/src";

export interface IAppProviderProps {
  backendUrl: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
}) => {
  const nextRouter = useNextRouter();
  const theme = useTheme();

   const onConnected = () => {
    console.log('Signal R connected');
  };

  const onDisconectedConnected = () => {
    console.log('Signal R diconnected');
  };

  return (
    <GlobalStateProvider>
      <AppProgressBar height="4px" color={theme.colorPrimary} shallowRouting />
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={nextRouter.path?.includes('/no-auth')}
      >
        <TelephonyProvider>
          <SignalRProvider hubUrl="/signalr-client" onConnected={onConnected} onDisconnected={onDisconectedConnected}>
            <TelephonyPlugin>
              {/* 0.46.0 renamed StoredFilesProvider; the backend url now comes from app context. */}
              <AttachmentsEditorProvider ownerId={""} ownerType={""}>
                {children}
              </AttachmentsEditorProvider>
            </TelephonyPlugin>
          </SignalRProvider>
        </TelephonyProvider>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
